/* istanbul ignore file */

/**
 * Конвертирует дату в секунды. См. примеры в тестах
 */
export const calculateSeconds = (date: Date, todayOnly = true): number => {
    const dateNow = new Date();

    if (todayOnly && date.getDate() !== dateNow.getDate()) {
        date.setDate(dateNow.getDate());
    }

    const secondsDiff = (date.getTime() - dateNow.getTime()) / 1000;

    return secondsDiff < 0 ? 0 : secondsDiff;
};
